module.exports = __webpack_public_path__ + "static/media/mmsys_116.1b77bb2e.ico";